export enum LangEnum {
  EN = 'EN',
  FR = 'FR',
  ESP = 'ESP',
}
